import React, { useState } from 'react';

// --- SVG Icon Components ---
const SendIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="2" x2="11" y2="13"></line>
    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
  </svg>
);

const HistoryIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <polyline points="12 6 12 12 16 14"></polyline>
    </svg>
);

// --- Main Broadcast Component ---
const BroadcastMessage = () => {
  const [recipient, setRecipient] = useState('');
  const [messageTitle, setMessageTitle] = useState('');
  const [messageContent, setMessageContent] = useState('');
  const [state, setState] = useState('');
  const [lga, setLga] = useState('');
  const [ward, setWard] = useState('');
  const [pollingUnit, setPollingUnit] = useState('');

  const historyItems = [
    {
        title: "Monthly Update",
        details: "Sent to 19,420 recipients on 7/15/2025",
        status: "Delivered"
    },
    {
        title: "LGA Emergency Protocol",
        details: "Sent to 1,500 recipients on 10/01/2024",
        status: "Delivered"
    },
    {
        title: "Monthly General Meeting Update",
        details: "Sent to 19,420 recipients on 7/15/2025",
        status: "Delivered"
    }
  ];

  const handleSendBroadcast = () => {
    // Handle send broadcast logic here
    console.log('Sending broadcast...');
  };

  return (
    <>
      <style>{`
        .broadcast-container {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 32px;
          width: 100%;
        }
        
        .broadcast-page {
          min-height: 100vh;
          background: linear-gradient(to bottom right, #F0F9FF, #FFFFFF);
          padding: 1rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif;
          width: 100%;
          overflow-x: hidden;
        }
        
        .broadcast-main-container {
          max-width: 100%;
          margin: 0 auto;
          width: 100%;
        }
        
        .filters-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1rem;
        }
        
        .send-button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background-color: #2563EB;
          color: white;
          padding: 12px 32px;
          border-radius: 6px;
          border: none;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          min-width: 200px;
          transition: background-color 0.2s;
          width: auto;
        }
        
        /* Mobile First Styles */
        @media (max-width: 1024px) {
          .broadcast-container {
            grid-template-columns: 1fr;
            gap: 20px;
          }
          
          .filters-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.75rem;
          }
          
          .send-button {
            width: 100%;
            min-width: auto;
          }
        }
        
        @media (max-width: 768px) {
          .broadcast-page {
            padding: 0.75rem;
          }
          
          .filters-grid {
            grid-template-columns: 1fr;
            gap: 0.75rem;
          }
          
          .history-item {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
          }
          
          .send-button-container {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: white;
            padding: 1rem;
            border-top: 1px solid #E5E7EB;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
            z-index: 100;
          }
          
          .broadcast-content {
            padding-bottom: 80px;
          }
        }
        
        @media (max-width: 480px) {
          .broadcast-page {
            padding: 0.5rem;
          }
          
          .stats-container,
          .history-container,
          .form-group-card {
            padding: 1rem;
          }
          
          .filters-section {
            padding: 1rem;
          }
        }
        
        /* Ensure no horizontal scroll */
        @media (max-width: 767px) {
          body {
            overflow-x: hidden;
          }
          
          .broadcast-page {
            overflow-x: hidden;
          }
          
          .broadcast-main-container {
            width: 100vw;
            padding: 0 0.5rem;
            box-sizing: border-box;
          }
        }
      `}</style>
      
      <div className="broadcast-page">
        <div className="broadcast-main-container">
          <div style={styles.header}>
            <h1 style={styles.h1}>Messages</h1>
            <p style={styles.subtitle}>Send messages to all members or specific groups</p>
          </div>
          
          <div className="broadcast-content">
            <div className="broadcast-container" style={{marginTop: '2rem'}}>
              {/* Left Column: Form */}
              <div style={styles.leftColumn}>
                  {/* Recipients */}
                  <div style={styles.formGroup} className="form-group-card">
                      <label style={styles.label} htmlFor="recipients">Recipients <span style={{color: '#EF4444'}}>*</span></label>
                      <select id="recipients" value={recipient} onChange={(e) => setRecipient(e.target.value)} style={styles.selectInput}>
                          <option value="">Select Recipient</option>
                          <option value="all">All Members</option>
                          <option value="group1">Group 1</option>
                      </select>
                  </div>

                  {/* Message Title */}
                  <div style={styles.formGroup} className="form-group-card">
                      <label style={styles.label} htmlFor="message-title">Message Title <span style={{color: '#EF4444'}}>*</span></label>
                      <input id="message-title" type="text" value={messageTitle} onChange={(e) => setMessageTitle(e.target.value)} style={styles.textInput} placeholder="Enter Message title..."/>
                  </div>

                  {/* Message Content */}
                  <div style={styles.formGroup} className="form-group-card">
                      <label style={styles.label} htmlFor="message-content">Message Content <span style={{color: '#EF4444'}}>*</span></label>
                      <textarea id="message-content" value={messageContent} onChange={(e) => setMessageContent(e.target.value)} style={styles.textareaInput} placeholder="Enter your Announcement Message...."></textarea>
                  </div>

                  {/* Location Filters */}
                  <div style={styles.filtersSection} className="filters-section">
                    <h3 style={styles.filtersTitle}>Target Audience Filters</h3>
                    <div className="filters-grid">
                      <div style={styles.filterGroup}>
                        <label style={styles.filterLabel}>State</label>
                        <select value={state} onChange={(e) => setState(e.target.value)} style={styles.filterSelect}>
                          <option value="">Select State</option>
                          <option value="lagos">Lagos</option>
                          <option value="abuja">Abuja</option>
                          <option value="kano">Kano</option>
                        </select>
                      </div>
                      
                      <div style={styles.filterGroup}>
                        <label style={styles.filterLabel}>LGA</label>
                        <select value={lga} onChange={(e) => setLga(e.target.value)} style={styles.filterSelect}>
                          <option value="">Select LGA</option>
                          <option value="ikeja">Ikeja</option>
                          <option value="surulere">Surulere</option>
                          <option value="gwarinpa">Gwarinpa</option>
                        </select>
                      </div>
                      
                      <div style={styles.filterGroup}>
                        <label style={styles.filterLabel}>Ward</label>
                        <select value={ward} onChange={(e) => setWard(e.target.value)} style={styles.filterSelect}>
                          <option value="">Select Ward</option>
                          <option value="ward-a">Ward A</option>
                          <option value="ward-b">Ward B</option>
                          <option value="ward-c">Ward C</option>
                        </select>
                      </div>
                      
                      <div style={styles.filterGroup}>
                        <label style={styles.filterLabel}>Polling Unit</label>
                        <select value={pollingUnit} onChange={(e) => setPollingUnit(e.target.value)} style={styles.filterSelect}>
                          <option value="">Select Polling Unit</option>
                          <option value="unit-001">Unit 001</option>
                          <option value="unit-002">Unit 002</option>
                          <option value="unit-003">Unit 003</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Send Button - Fixed on mobile */}
                  <div style={styles.sendButtonContainer} className="send-button-container">
                    <button className="send-button" onClick={handleSendBroadcast}>
                        <SendIcon />
                        Send Broadcast
                    </button>
                  </div>
              </div>

              {/* Right Column: Stats & History */}
              <div style={styles.rightColumn}>
                {/* Stats */}
                <div style={styles.statsContainer} className="stats-container">
                    <h2 style={styles.h2}>Broadcast Statistics</h2>
                    <div style={styles.statsItem}>
                        <span>Total Sent</span>
                        <span style={styles.statsValue}>1,247</span>
                    </div>
                    <div style={styles.statsItem}>
                        <span>This Month</span>
                        <span style={styles.statsValueBlue}>23</span>
                    </div>
                </div>

                {/* History */}
                <div style={styles.historyContainer} className="history-container">
                  <div style={styles.historyHeader}>
                      <HistoryIcon />
                      <h2 style={styles.historyTitleText}>History</h2>
                  </div>
                  <div>
                      {historyItems.map((item, index) => (
                          <div key={index} style={styles.historyItem} className="history-item">
                              <div>
                                  <p style={styles.historyTitle}>{item.title}</p>
                                  <p style={styles.historyDetails}>{item.details}</p>
                              </div>
                              <span style={styles.deliveredBadge}>{item.status}</span>
                          </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// --- Internal CSS Styles Object ---
const styles = {
    header: {
        padding: '0 0.5rem',
    },
    h1: {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#2563EB',
        margin: '0 0 8px 0',
        lineHeight: '1.3',
    },
    subtitle: {
        color: '#6B7280',
        fontSize: '14px',
        margin: '0',
        lineHeight: '1.5',
    },
    leftColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    rightColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    formGroup: {
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    label: {
        display: 'block',
        fontSize: '14px',
        fontWeight: '500',
        color: '#374151',
        marginBottom: '8px',
    },
    selectInput: {
        width: '100%',
        padding: '12px',
        border: '1px solid #D1D5DB',
        borderRadius: '6px',
        fontSize: '14px',
        backgroundColor: 'white',
        boxSizing: 'border-box',
    },
    textInput: {
        width: '100%',
        padding: '12px',
        border: '1px solid #D1D5DB',
        borderRadius: '6px',
        fontSize: '14px',
        boxSizing: 'border-box',
    },
    textareaInput: {
        width: '100%',
        padding: '12px',
        border: '1px solid #D1D5DB',
        borderRadius: '6px',
        fontSize: '14px',
        minHeight: '120px',
        resize: 'vertical',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
    },
    // Improved Filters Section
    filtersSection: {
        backgroundColor: '#F8FAFC',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '1px solid #E2E8F0',
    },
    filtersTitle: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1E293B',
        margin: '0 0 1rem 0',
    },
    filterGroup: {
        display: 'flex',
        flexDirection: 'column',
    },
    filterLabel: {
        fontSize: '12px',
        fontWeight: '500',
        color: '#475569',
        marginBottom: '6px',
    },
    filterSelect: {
        padding: '10px 12px',
        backgroundColor: 'white',
        color: '#334155',
        border: '1px solid #CBD5E1',
        borderRadius: '6px',
        fontSize: '14px',
        fontWeight: '400',
        width: '100%',
        boxSizing: 'border-box',
    },
    // Send Button Container
    sendButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
    statsContainer: {
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    h2: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#111827',
        margin: '0 0 1rem 0',
    },
    statsItem: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '14px',
        color: '#6B7280',
        marginBottom: '0.75rem',
        padding: '0.5rem 0',
    },
    statsValue: {
        fontWeight: 'bold',
        color: '#1F2937',
        fontSize: '16px',
    },
    statsValueBlue: {
        fontWeight: 'bold',
        color: '#2563EB',
        fontSize: '16px',
    },
    historyContainer: {
        backgroundColor: 'white',
        padding: '1.5rem',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    historyHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '1rem'
    },
    historyTitleText: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#111827',
        margin: '0',
        lineHeight: '1.2',
    },
    historyItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1rem 0',
        borderBottom: '1px solid #F3F4F6',
    },
    historyTitle: {
        fontSize: '14px',
        fontWeight: '500',
        color: '#111827',
        margin: '0 0 4px 0',
        lineHeight: '1.4',
    },
    historyDetails: {
        fontSize: '12px',
        color: '#9CA3AF',
        margin: 0,
        lineHeight: '1.4',
    },
    deliveredBadge: {
        backgroundColor: '#D1FAE5',
        color: '#065F46',
        padding: '6px 12px',
        borderRadius: '9999px',
        fontSize: '12px',
        fontWeight: '500',
        whiteSpace: 'nowrap',
    }
};

export default BroadcastMessage;